import { Link } from "wouter";
import { AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center" style={{ backgroundColor: "#05070a", color: "#ffffff" }}>
      <div className="w-full max-w-md mx-4 rounded-2xl p-10 text-center" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(99,102,241,0.18)" }}>
        <AlertCircle className="h-12 w-12 mx-auto mb-4" style={{ color: "#6366f1" }} />
        <h1 className="text-2xl font-bold text-white mb-3">404 — Page Not Found</h1>
        <p className="text-sm mb-6" style={{ color: "#94a3b8" }}>
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link href="/">
          <button className="px-6 py-2.5 rounded-lg text-sm font-semibold text-white transition-colors" style={{ backgroundColor: "#6366f1" }}>
            Back to Home
          </button>
        </Link>
      </div>
    </div>
  );
}
